import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';


//mui

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

//redux
import { connect } from 'react-redux';
import { submitComment } from '../../redux/actions/dataActions';

const styles = (theme) => ({
    ...theme.spread,


});
export class CommentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            body: '',
            errors: {}
        }
    }

    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState(() => {
            return {
                [name]: value
            }
        })
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.submitComment(this.props.soundOffId, { body: this.state.body });
        this.setState(() => {
            return {
                body: ''
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.UI.errors) {
            this.setState(() => {
                return {
                    errors: nextProps.UI.errors
                }
            })
        }
        if (!nextProps.UI.erros && !nextProps.UI.loading) {
            this.setState(() => {
                return {
                    body: ''
                }
            })
        }
    }

    render() {
        const { classes, authenticated } = this.props;
        const errors = this.state.errors;
        const commentFormMarkUp = authenticated ? (
            <Grid item sm={12} style={{ textAlign: 'center' }} >
                <form onSubmit={this.handleSubmit}>
                    <TextField name='body' type='text' label='Comment' error={errors.comment ? true : false} helperText={errors.comment} value={this.state.body} onChange={this.handleChange} fullWidth className={classes.textField} />
                    <Button type='submit' color='primary' variant='contained' className={classes.button}>
                        Submit
                    </Button>
                </form>
                <hr className={classes.visibleHR} />

            </Grid>
        ) : null;
        return commentFormMarkUp;

    }
}

CommentForm.propTypes = {
    UI: PropTypes.object.isRequired,
    authenticated: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    submitComment: PropTypes.func.isRequired,
    soundOffId: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
    UI: state.UI,
    authenticated: state.user.authenticated
})

export default connect(mapStateToProps, { submitComment })(withStyles(styles)(CommentForm));
